import React from 'react'

export const Footer = () => {
  return (
    <div className='container-fluid footer'>
        <span>Ya'axché Comunidad Sustentable, 2026</span>
        <span>Desarrollado por <a href="https://www.instagram.com/matherperformace/"><b>Mather Performance</b></a></span>
    </div>
  )
}
